import React, { FC } from 'react';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Card } from 'antd';
import SiteSurveyForm from '../site_survey_form/SiteSurveyForm';
import { withUserType } from '../withUserType';

const { Content } = Layout;

const NewSiteSurveyPage: FC<any> = ({ history, userType }): React.ReactElement => {
	return (
		<Content>
			<Row style={{ margin: '0.5em -8px' }} gutter={16}>
				<Col span={24}>
					<Card>
						<div>
							<h5 style={{ marginBottom: 24 }}>New Site Surveys</h5>
							<SiteSurveyForm
								formData={{}}
								onSuccess={(rec) => history.push(`/${userType}/siteSurveys/overview/all`)}
							/>
						</div>
					</Card>
				</Col>
			</Row>
		</Content>
	);
};

export default withUserType(withRouter(NewSiteSurveyPage as any) as any);
